import type { PageHelp } from '../network-help.data';

export const L10N_ar_g3: Record<string, PageHelp> = {
  'flights-search': {
    title: 'الطيران',
    tag: 'البحث عن الرحلات الجوية',
    tagline: 'مسار نقطة البيع لحجز الرحلات الجوية من كل مورّد يمكن للوكالة إصدار تذاكره.',
    business: {
      lead: 'الطيران هو المكان الذي تحوّل فيه الوكالة رحلة العميل إلى تذكرة. كل نتيجة على هذه الشاشة قابلة للإصدار — إما مقابل SIGN الخاص بالوكالة أو عبر SIGN شريك مُنح لها حق الوصول إليه — لذا فإن الأسعار المعروضة هي الأسعار التي يمكن للوكالة بيعها فعليًا دون خطوة موافقة إضافية.',
      points: [
        { title: 'بحث واحد عبر قنوات متعددة', desc: 'يُوزَّع الاستعلام الواحد على كل مصدر محتوى نشط لدى الوكالة (SIGN الخاص، وSIGN المُستعارة عبر وصول الشركاء، وموجزات NDC/GDS) وتُدمج النتائج في قائمة واحدة مرتّبة حسب السعر.' },
        { title: 'التسعير الطبقي يُطبَّق هنا', desc: 'الأسعار المعروضة تتضمّن بالفعل هوامش Wholesale (لمالك SIGN) وDistribution (القناة) وRetail (الخاص) من محرّك التسعير — ما يراه العميل هو ما تنوي الوكالة تحصيله.' },
        { title: 'المسافر أولًا، لا السعر أولًا', desc: 'أنواع الركاب (بالغ / طفل / رضيع) وتواريخ السفر تحدّد كلًّا من السعر وأهلية الاسترداد / إعادة الحجز لاحقًا، لذا فإن نموذج الإدخال مهم.' },
      ],
    },
    software: {
      lead: 'شاشة بحث عن الأسعار موصولة بواجهة برمجة توفّر إتاحة حقيقية، مع نتائج مجمّعة حسب السعر وSIGN المُصدِر.',
      points: [
        { title: 'صياغة الاستعلام', desc: 'المنشأ والوجهة والتواريخ وأعداد الركاب تحرّك البحث؛ ويمكن تضييق الدرجة / شركة الطيران / المقصورة بعد مجموعة النتائج الأولى.' },
        { title: 'قراءة صف النتائج', desc: 'كل صف يعرض السعر وشركة الطيران والمقصورة وأي SIGN ستُصدَر التذكرة مقابله — الشارة على اليمين.' },
        { title: 'التقدّم نحو الحجز', desc: 'اختيار سعر يفتح تفاصيل العرض؛ ومن هناك يكمل مسار نموذج الركاب / خريطة المقاعد / الدفع الحجز إلى سجل حجز.' },
      ],
    },
    flow: {
      lead: 'المسار الكامل من طلب العميل إلى تذكرة مُصدَرة.',
      steps: [
        { title: 'إدخال الرحلة', desc: 'المنشأ والوجهة، ذهاب فقط أو ذهاب وعودة، تواريخ السفر، وأعداد البالغين / الأطفال / الرضّع.' },
        { title: 'تشغيل البحث', desc: 'تُوزَّع النتائج على كل مورّد نشط وتُدمج في قائمة واحدة مرتّبة حسب السعر.' },
        { title: 'التصفية والترتيب', desc: 'تضييق حسب شركة الطيران والمقصورة والتوقفات ووقت المغادرة؛ وSIGN المُصدِر ظاهر على كل صف.' },
        { title: 'فتح العرض', desc: 'تفاصيل العرض تُظهر قواعد الأجرة والأمتعة وسياسة الاسترداد وإعادة الحجز — اقرأها قبل الالتزام.' },
        { title: 'تسجيل الركاب', desc: 'املأ نموذج الراكب (الاسم، تاريخ الميلاد، الوثيقة، المسافر الدائم) لكل مسافر؛ ومنتقي إدارة علاقات العملاء يعبّئ مسبقًا من العملاء المحفوظين.' },
        { title: 'اختيار المقاعد والخدمات الإضافية', desc: 'منتقي خريطة المقاعد والخدمات المدفوعة (الأمتعة، الوجبات) إضافات اختيارية على العرض.' },
        { title: 'الدفع والإصدار', desc: 'يُحصَّل الدفع مقابل محفظة الوكالة / خط الائتمان؛ ويُحجَز PNR وتُصدَر التذكرة الإلكترونية.' },
      ],
    },
    modes: {
      lead: 'يُلبَّى عرض الطيران عبر أحد ثلاثة أنماط توريد — الشارة على كل نتيجة تخبرك بأيّها تحصل.',
      modes: [
        { name: 'Own SIGN', when: 'تمتلك الوكالة بيانات اعتماد BSP / GDS مباشرة', desc: 'تُصدَر تذكرة الوكالة مقابل SIGN الخاص بها. حصة عمولة كاملة، وأسرع إصدار، وأوثق حلقة دعم مع شركة الطيران.' },
        { name: 'Partner SIGN', when: 'تستخدم الوكالة منحة وكالة أخرى', desc: 'تُصدَر مقابل SIGN مُنح عبر وصول الشركاء. تأخذ طبقة Wholesale في محرّك التسعير هامش مالك SIGN.' },
        { name: 'NDC / connected', when: 'لا علاقة BSP مع تلك الشركة', desc: 'يأتي السعر من موجز NDC أو مجمِّع. قد تختلف القواعد عن محتوى GDS (يعالج الموصّل عمليات الاسترداد، وقد تكون خريطة المقاعد محدودة).' },
      ],
    },
    examples: [
      {
        title: 'ذهاب وعودة درجة رجال الأعمال DXB ← LHR · بالغان · own SIGN',
        rows: [
          { label: 'الأجرة الأساسية (لكل راكب) × 2', value: '28,000,000' },
          { label: 'الضرائب وYQ', value: '4,200,000' },
          { label: 'Wholesale MARKUP · غير قابل للتطبيق (own SIGN)', value: '0' },
          { label: 'Retail MARKUP · +5% من الإجمالي', value: '+1,610,000', accent: 'success' },
          { label: 'إجمالي المسافر', value: '33,810,000', strong: true },
        ],
        note: 'إصدار own-SIGN يتخطّى طبقة Wholesale بالكامل — مالك SIGN هو البائع، لذا لا يوجد هامش موزّع لدفعه.',
      },
      {
        title: 'الرحلة نفسها · partner SIGN مُستعار',
        rows: [
          { label: 'الأجرة الأساسية + الضرائب', value: '32,200,000' },
          { label: 'Wholesale MARKUP · +4% (حصة الشريك)', value: '+1,288,000', accent: 'info' },
          { label: 'Retail MARKUP · +5% من الإجمالي', value: '+1,674,400', accent: 'success' },
          { label: 'إجمالي المسافر', value: '35,162,400', strong: true },
        ],
        note: 'تدفع طبقة Wholesale للوكالة الشريكة مقابل منحة SIGN. ثم يُحسَب Retail على الإجمالي الجاري الجديد.',
      },
    ],
    related: ['hotels-search', 'markup', 'signs', 'partner-access'],
  },

  'hotels-search': {
    title: 'الفنادق',
    tag: 'البحث عن الفنادق',
    tagline: 'مسار البحث والحجز لإقامات الفنادق عبر المخزون الخاص والموردين المتصلين.',
    business: {
      lead: 'تتيح الفنادق للوكالة بيع إقامة سواء أتت الغرفة من المخزون المتعاقَد عليه الخاص بالوكالة، أو من مخزون شريك مُشارَك عبر منحة، أو من مورّد خارجي متصل. يتعايش نمطا بيع: فوري (يؤكّد المشغّل مسبقًا) وعند الطلب (يحتفظ المشغّل بالطلب حتى يؤكّده مورّد)، وتوضّح الشاشة أي نمط ينطبق على كل نتيجة.',
      points: [
        { title: 'التوريد الخاص مقابل المتصل', desc: 'الغرف المتعاقَد عليها الخاصة موجودة في وحدة عقارات الفنادق بالمنصّة؛ ويأتي التوريد المتصل من مزوّدين خارجيين. يدمج المحرّك كليهما في مجموعة نتائج واحدة.' },
        { title: 'فوري أو عند الطلب', desc: 'نتائج الفوري تؤكَّد عند الحجز؛ ونتائج عند الطلب تُسعَّر وتُحتجَز حتى يقبلها المشغّل (أو المورّد) — ويتباعد سير العمل انطلاقًا من ذلك القرار.' },
        { title: 'التسعير الليلي = تسعير طبقي', desc: 'السعر الليلي المعروض يتضمّن بالفعل طبقات محرّك التسعير Wholesale / Distribution / Retail؛ ويمكن أيضًا تطبيق خصومات ليلية شاملة (مثل القائمة على طول الإقامة).' },
      ],
    },
    software: {
      lead: 'شاشة بحث حسب الوجهة بنتائج غرف / خطط أسعار وتقسيم بين الحجز الآن / الطلب للحجز.',
      points: [
        { title: 'البحث حسب الوجهة + التواريخ', desc: 'المدينة وتاريخا الوصول / المغادرة والغرف تحرّك البحث الأساسي؛ والمرشّحات (التصنيف بالنجوم، خطة الإقامة، السلسلة) تضيّق النتائج.' },
        { title: 'قراءة شارة النمط', desc: 'كل بطاقة عقار تحمل شارة فوري أو عند الطلب ليكون نمط البيع ظاهرًا قبل أن يلتزم المشغّل.' },
        { title: 'المتابعة للحجز أو الطلب', desc: 'اختيار غرفة يتقدّم إلى نموذج الضيف ومسار الدفع للفوري؛ وللطلب يفتح نموذج طلب يصبح حجزًا معلّقًا حتى يؤكّده المشغّل.' },
      ],
    },
    flow: {
      lead: 'من «أحتاج غرفة في دبي الأسبوع القادم» إلى حجز مؤكَّد (أو طلب محتجَز).',
      steps: [
        { title: 'إدخال الإقامة', desc: 'مدينة الوجهة، تاريخا الوصول / المغادرة، عدد الغرف وأعداد الضيوف.' },
        { title: 'تشغيل البحث', desc: 'تدمج النتائج الغرف المتعاقَد عليها الخاصة وموجزات الموردين المتصلين في قائمة واحدة مرتّبة حسب السعر.' },
        { title: 'تصفية العقارات', desc: 'تضييق حسب التصنيف بالنجوم ونوع الإقامة والسلسلة والمسافة إلى المركز ونطاق السعر؛ وتُظهر كل بطاقة شارة فوري أو عند الطلب.' },
        { title: 'فتح العقار', desc: 'أنواع الغرف وخطط الأسعار وسياسة الإلغاء والإقامة والمشمولات كلها في شاشة تفاصيل العقار.' },
        { title: 'اختيار خطة أسعار', desc: 'اختر خطة الأسعار للحجز (غرفة فقط، B&B، نصف إقامة، غير قابلة للاسترداد) والسعر الليلي الناتج.' },
        { title: 'تسجيل الضيوف + الدفع', desc: 'نموذج الضيف + الدفع للفوري. وللطلب، قدّم الطلب — ويُحتجَز الحجز بانتظار التأكيد.' },
        { title: 'الحصول على القسيمة', desc: 'بمجرد التأكيد، تُرفَق قسيمة الفندق وتأكيد المورّد بسجل الحجز.' },
      ],
    },
    modes: {
      lead: 'شارة فوري / عند الطلب على كل نتيجة تخبر المشغّل بكيفية تأكيد الحجز ومتى تتحرك الأموال.',
      modes: [
        { name: 'Instant', when: 'مخزون خاص أو مورّد متصل بإتاحة فورية', desc: 'يُؤكَّد الحجز عند النقر. يُحصَّل الدفع فورًا. تُصدَر القسيمة مباشرةً بعدها. ويُخصَم من المخصّص على الفور.' },
        { name: 'On-Request', when: 'مورّد خارجي دون إتاحة فورية، أو استعلام خارج المخصّص', desc: 'يُحتجَز الحجز كطلب معلّق حتى يقبله المشغّل (أو المورّد). لا يُخصَم شيء من المخصّص حتى التأكيد؛ ويُحصَّل الدفع عند التأكيد، لا وقت الطلب.' },
        { name: 'Own inventory', when: 'لدى الوكالة عقود مباشرة', desc: 'تُوفَّر الغرف من وحدة عقارات الفنادق بالمنصّة. وتُدار المخصّصات وخطط الأسعار وسياسات الإلغاء من الوكالة نفسها.' },
        { name: 'Connected supply', when: 'موجز مورّد خارجي', desc: 'تأتي الغرف من واجهة برمجة شريك (بنك أسرّة، مجمِّع). وتتبع السياسات + مسار الاسترداد عقد المورّد، لا عقد الوكالة.' },
      ],
    },
    examples: [
      {
        title: 'إقامة 3 ليالٍ · غرفة واحدة · ضيفان · نصف إقامة · Instant',
        rows: [
          { label: 'السعر الليلي × 3 ليالٍ', value: '9,000,000' },
          { label: 'Wholesale MARKUP · +3% (هامش المورّد)', value: '+270,000', accent: 'info' },
          { label: 'Retail MARKUP · +6% من الإجمالي', value: '+556,200', accent: 'success' },
          { label: 'إجمالي المسافر', value: '9,826,200', strong: true },
        ],
        note: 'يؤكّد Instant فورًا؛ وينخفض المخصّص على خطة الأسعار بمقدار غرفة-ليلة واحدة لكل ليلة من الليالي الثلاث.',
      },
      {
        title: 'الإقامة نفسها · On-Request',
        rows: [
          { label: 'الإجمالي المُسعَّر (محتجَز، غير محصّل)', value: '9,826,200' },
          { label: 'عند التأكيد', value: 'يُحصَّل الدفع', accent: 'success' },
          { label: 'عند الرفض', value: 'لا يُحصَّل شيء', accent: 'info' },
        ],
        note: 'تثبّت عروض On-Request السعر لنافذة اتفاقية مستوى الخدمة. وإذا لم يستطع المورّد التأكيد داخل تلك النافذة، ينقضي الطلب تلقائيًا.',
      },
    ],
    related: ['tours', 'markup', 'reference-data'],
  },

  tours: {
    title: 'الجولات',
    tag: 'باقات الجولات',
    tagline: 'باقات قابلة للحجز متعددة الخدمات — فندق + طيران + أنشطة — تُباع كسطر واحد.',
    business: {
      lead: 'تحوّل الجولات حزمة (فندق + طيران + خدمات نقل ووجبات وأنشطة اختيارية) إلى منتج واحد قابل للبيع. والقيمة التجارية هي الهامش المُجمَّع: يمكن للمشغّل تسعير الحزمة لممرّ طلب محدّد (فرق الشركات، الحج، عطلات العائلات) دون كشف أسعار كل مكوّن على حدة.',
      points: [
        { title: 'وحدة تخزين واحدة، مكوّنات كثيرة', desc: 'باقة الجولة سجل واحد قابل للحجز رغم أنها تجمع رحلات وغرفًا وخدمات؛ وهذا يجعل نسبة الإيراد والإلغاء أنظف من بيع المكوّنات منفصلة.' },
        { title: 'المغادرات والمخزون', desc: 'تُعرض الباقة على تواريخ مغادرة محدّدة بحدّ أقصى ثابت؛ وتسقط التواريخ المُباعة بالكامل من النتائج تلقائيًا.' },
        { title: 'محرّك التسعير نفسه', desc: 'التسعير الطبقي لا يزال ينطبق — الجولة ليست معفاة من مجموعة قواعد Wholesale / Distribution / Retail.' },
      ],
    },
    software: {
      lead: 'شاشة بحث عن الباقات مدعومة بكتالوج الجولات، بمرشّحات لتاريخ المغادرة والمشمولات.',
      points: [
        { title: 'العثور على باقة', desc: 'الوجهة ونافذة المغادرة وأعداد المسافرين تحرّك النتائج؛ ومرشّحات الفئة والمشمولات تضيّق أكثر.' },
        { title: 'فحص الباقة', desc: 'اختيار باقة يفتح مسار رحلتها الكامل وقائمة مشمولاتها قبل الالتزام بتاريخ مغادرة.' },
        { title: 'الحجز على مغادرة', desc: 'اختر تاريخًا، وسجّل الركاب عبر درج تسجيل الجولة، وأكمل الدفع — والنتيجة حجز جولة واحد، لا حجز لكل مكوّن.' },
      ],
    },
    flow: {
      lead: 'من «نريد رحلة إلى جورجيا في أكتوبر» إلى باقة مؤكَّدة على مغادرة محدّدة.',
      steps: [
        { title: 'إدخال الرحلة', desc: 'دولة / منطقة الوجهة، شهر المغادرة، أعداد البالغين / الأطفال / الرضّع.' },
        { title: 'تصفّح النتائج', desc: 'تُظهر البطاقات عنوان الباقة والمدة والمشمولات الرئيسية وسعر «ابتداءً من» لأرخص مغادرة.' },
        { title: 'فتح الباقة', desc: 'تُظهر شاشة التفاصيل مسار الرحلة يومًا بيوم والمشمولات والمستثنيات ومكوّنات الفندق + الطيران وسياسة الإلغاء.' },
        { title: 'اختيار مغادرة', desc: 'يُظهر تقويم المغادرة التواريخ المتاحة بأسعار لكل تاريخ والمقاعد المتبقية؛ والتواريخ المُباعة بالكامل معتّمة.' },
        { title: 'تسجيل المسافرين', desc: 'يجمع درج تسجيل الجولة وثيقة كل راكب ووجبته وتفضيل مشاركة الغرفة وأي اشتراك في نشاط.' },
        { title: 'الدفع والتأكيد', desc: 'دفعة واحدة تُغلق الباقة. وتُرفَق كل قسائم المكوّنات (طيران، فندق، أنشطة) بحجز الجولة الواحد.' },
      ],
    },
    modes: {
      lead: 'تُصنَّف الجولات على محورين متعامدين — طول الرحلة ونموذج المغادرة.',
      modes: [
        { name: 'Fixed departure', when: 'جولة جماعية بتاريخ وحدّ أقصى محدّدين', desc: 'تسافر المجموعة كلها وتقيم معًا في التواريخ المحدّدة مسبقًا. تمتلئ المغادرات حتى بلوغ الحدّ الأقصى ثم تُغلَق.' },
        { name: 'Private / on-demand', when: 'مسافر مستقل يريد تواريخه الخاصة', desc: 'يُعاد استخدام إطار الباقة (الفنادق، النقل، الأنشطة) لكن تتحوّل الرحلات ومسار الرحلة إلى تواريخ المسافر.' },
        { name: 'Land-only', when: 'يُحجَز الطيران في مكان آخر', desc: 'فندق + نقل + أنشطة دون مكوّن الطيران — مسعّرة بأقل ويُحضِر المسافر تذكرته الخاصة.' },
        { name: 'Full package', when: 'الافتراضي', desc: 'طيران + فندق + نقل + أنشطة بسعر واحد. أعلى هامش لكل حجز، والأبسط بيعًا لمسافر لأول مرة.' },
      ],
    },
    examples: [
      {
        title: 'باقة جورجيا 5 أيام · بالغان · Full package',
        rows: [
          { label: 'مكوّن الطيران (راكبان)', value: '12,000,000' },
          { label: 'مكوّن الفندق (4 ليالٍ × راكبان)', value: '18,000,000' },
          { label: 'النقل + الأنشطة', value: '5,000,000' },
          { label: 'تكلفة الباقة الأساسية', value: '35,000,000' },
          { label: 'Wholesale MARKUP · +5%', value: '+1,750,000', accent: 'info' },
          { label: 'Retail MARKUP · +8% من الإجمالي', value: '+2,940,000', accent: 'success' },
          { label: 'إجمالي المسافر', value: '39,690,000', strong: true },
        ],
        note: 'تكلفة الباقة الواحدة تخفي أسعار المكوّنات عن العميل — يسوّق المشغّل سعرًا رئيسيًا بدلًا من الدفاع عن ثلاثة بنود منفصلة.',
      },
    ],
    related: ['hotels-search', 'flights-search', 'markup'],
  },

  'trains-search': {
    title: 'القطارات',
    tag: 'البحث عن السكك الحديدية',
    tagline: 'البحث والحجز لرحلات السكك الحديدية عبر مشغّلي السكك المتصلين.',
    business: {
      lead: 'تبيع القطارات السكك الحديدية كبديل أو مكمّل للرحلات الجوية على الممرات الداخلية وقصيرة المدى. يختلف الشكل التجاري للسكك عن الطيران (من محطة إلى محطة، قائم على الدرجة لا على المقصورة، بقواعد إلغاء أضيق) وتوضّح الشاشة تلك الفروق صراحةً بحيث يختار الوكيل الذي يسعّر رحلة المنتج المناسب لطول الرحلة.',
      points: [
        { title: 'إيقاع تسعير مختلف', desc: 'لا تتأرجح أسعار السكك دقيقة بدقيقة كالطيران؛ إذ تعني الجداول الثابتة أن السعر نفسه متاح غالبًا لساعات، فتكون التسعيرات أكثر استقرارًا.' },
        { title: 'الدرجة أهم من شركة الطيران', desc: 'الاختيار بين الدرجة الاقتصادية / الأولى / رجال الأعمال على القطار نفسه، لا بين ناقلين متنافسين — محور قرار المشتري مختلف.' },
        { title: 'تذاكر محجوزة مقابل مفتوحة', desc: 'تتطلّب بعض المسارات حجز مقعد، وتقبل أخرى تذاكر مفتوحة؛ ويتكيّف المسار حسب المشغّل.' },
      ],
    },
    software: {
      lead: 'بحث من محطة إلى محطة بمرشّحات للرحلة / الدرجة / المشغّل.',
      points: [
        { title: 'صياغة الرحلة', desc: 'محطتا المنشأ والوجهة وتاريخ المغادرة وعدد الركاب تحرّك البحث.' },
        { title: 'قراءة صف الرحلة', desc: 'كل نتيجة تُظهر المشغّل وخيارات الدرجة والسعر لكل درجة؛ ووقت العبور والتوقفات على الصف.' },
        { title: 'التقدّم نحو الحجز', desc: 'اختيار سعر يفتح مسار نموذج الراكب / اختيار المقعد، ثم الدفع؛ ويتصرّف الحجز الناتج كأي حجز آخر.' },
      ],
    },
    flow: {
      lead: 'حجز السكك أقل أجزاءً متحرّكة من الطيران — لكن حجز المقعد واختيار الدرجة يحلّان محل اختيار المقصورة.',
      steps: [
        { title: 'اختيار المحطات', desc: 'محطتا المنشأ والوجهة (لا المدن — فقد يكون للمدينة عدة محطات، واختيار الصحيحة يوفّر على المسافر أجرة سيارة أجرة).' },
        { title: 'اختيار التاريخ', desc: 'السكك أقل حساسية للتاريخ من حيث السعر مقارنة بالطيران؛ ويُحتفَظ بالسعر نفسه عادةً طوال يوم التشغيل.' },
        { title: 'قراءة قائمة الرحلات', desc: 'تُدرَج مغادرات اليوم بالمدة والتوقفات وخيارات الدرجة والسعر لكل درجة.' },
        { title: 'اختيار درجة', desc: 'الاقتصادية أو الأولى أو رجال الأعمال تغيّر راحة المقعد و(لدى بعض المشغّلين) شمول الوجبة / الصالة.' },
        { title: 'حجز مقعد', desc: 'لدى المشغّلين الذين يتطلبون الحجز، يفتح منتقي خريطة المقاعد بعد اختيار الدرجة؛ ويتخطّى مشغّلو التذاكر المفتوحة هذه الخطوة.' },
        { title: 'تسجيل الركاب + الدفع', desc: 'نموذج راكب قياسي + دفع؛ وتُرفَق التذكرة الإلكترونية / رمز QR بالحجز.' },
      ],
    },
    modes: {
      lead: 'تختلف أسعار السكك عن الطيران على محورين — ما إذا كانت التذكرة مرتبطة بمقعد محدّد، وما الذي تشتريه لك الدرجة فعليًا.',
      modes: [
        { name: 'Reserved seat', when: 'مشغّلو الفائقة السرعة / طويلة المدى', desc: 'التذكرة مقيّدة بقطار ومقعد محدّدين. إن فاتك القطار بطلت التذكرة (أو خضعت لرسم إعادة حجز). خريطة المقاعد متاحة عند الحجز.' },
        { name: 'Open ticket', when: 'مسارات الركّاب اليومية / قصيرة المدى', desc: 'صالحة على أي قطار من درجة ضمن نافذة صلاحية (عادةً يوم السفر). لا خريطة مقاعد — الأسبقية للأسبق في عربة الدرجة.' },
        { name: 'Economy class', when: 'نقطة السعر الافتراضية', desc: 'جلوس قياسي، دون مشمولات إضافية. الجزء الأكبر من حجوزات السكك.' },
        { name: 'First class', when: 'مسافرو رجال الأعمال', desc: 'مسافة مقعد أوسع، عربة أهدأ، وأحيانًا وجبة خفيفة أو دخول الصالة.' },
        { name: 'Business class', when: 'طويلة المدى المتميّزة', desc: 'لدى بعض المشغّلين فقط. مقعد بمكتب، وطاقة كهربائية، وأولوية صعود، وخدمة وجبات كاملة.' },
      ],
    },
    examples: [
      {
        title: 'طهران ← مشهد · بينية · الدرجة الأولى · راكبان',
        rows: [
          { label: 'الأجرة الأساسية (لكل راكب) × 2', value: '3,200,000' },
          { label: 'Retail MARKUP · +5%', value: '+160,000', accent: 'success' },
          { label: 'إجمالي المسافر', value: '3,360,000', strong: true },
        ],
        note: 'تتجاوز السكك عادةً طبقة Wholesale — يبيع المشغّل بالأجرة المنشورة، وهامش الوكالة الوحيد هو Retail.',
      },
    ],
    related: ['buses-search', 'flights-search', 'markup'],
  },

  'buses-search': {
    title: 'الحافلات',
    tag: 'البحث عن الحافلات',
    tagline: 'مسارات الحافلات لمسافات طويلة على الممرات التي يفوز فيها النقل البرّي بالسعر أو الوصول.',
    business: {
      lead: 'تغطّي الحافلات الممرات التي تكون فيها الحافلة إما الخيار الواقعي الوحيد أو أرخص بوضوح من الطيران / السكك. ودورها التجاري هو التغطية: تتيح للوكالة حجز رحلة كاملة من البداية للنهاية لعميل يمرّ مساره ببلدات بلا مطار أو محطة سكك.',
      points: [
        { title: 'التغطية على حساب السرعة', desc: 'تصل الحافلات إلى مدن وبلدات لا تصلها الرحلات الجوية والسكك — أمر حاسم للحج والسفر التجاري الإقليمي ووصلات الميل الأخير.' },
        { title: 'أسعار بسيطة ملائمة للنقد', desc: 'أسعار الحافلات عادةً ثابتة لكل مقعد بدرجات علامة أقل، ما يجعل التسعير بالجملة / للشركات مباشرًا.' },
        { title: 'أجزاء مورّد متحرّكة أقل', desc: 'يكشف معظم المشغّلين جدولًا ثابتًا بدلًا من الإتاحة الديناميكية، لذا تكون نتائج البحث مستقرة على مدار اليوم.' },
      ],
    },
    software: {
      lead: 'بحث من مدينة إلى مدينة بمرشّحات للمشغّل / درجة المقعد، مركون حاليًا بانتظار تكامل الواجهة الخلفية.',
      points: [
        { title: 'صياغة الرحلة', desc: 'مدينتا المنشأ والوجهة وتاريخ المغادرة وعدد الركاب تحرّك البحث.' },
        { title: 'قراءة صف المسار', desc: 'كل نتيجة تُظهر المشغّل والمدة والسعر؛ وتُفتح خيارات درجة المقعد عند الاختيار.' },
        { title: 'التقدّم نحو الحجز', desc: 'المقعد المختار يفتح مسار الراكب والدفع؛ وينضمّ السجل إلى كل الحجوزات كأي منتج آخر.' },
      ],
    },
    flow: {
      lead: 'حجز حافلة هو أبسط مسارات النقل — جدول ثابت، ودرجة مقعد واحدة لكل مسار (عادةً)، وأجرة ثابتة واحدة لكل مقعد.',
      steps: [
        { title: 'اختيار المنشأ + الوجهة', desc: 'المدن (لا المحطات — عادةً للمشغّل محطة واحدة لكل مدينة).' },
        { title: 'اختيار التاريخ', desc: 'يُحمَّل جدول اليوم الكامل — ولا تتأرجح الأسعار على مدار اليوم.' },
        { title: 'اختيار مغادرة', desc: 'كل صف مغادرة واحدة: المشغّل، درجة المقعد، السعر، ووقت السفر المقدّر.' },
        { title: 'اختيار مقعد', desc: 'تُفتح خريطة مقاعد لدى المشغّلين الذين يدعمونها؛ وإلا تُخصَّص التذكرة عند الصعود.' },
        { title: 'تسجيل الركاب + الدفع', desc: 'نموذج راكب قياسي + دفع؛ وتُرفَق رمز QR / التذكرة الإلكترونية بالحجز.' },
      ],
    },
    modes: {
      lead: 'يشحن مشغّلو الحافلات غالبًا درجة خدمة واحدة، لكن تجربة اختيار المقعد تتفاوت.',
      modes: [
        { name: 'Assigned seat', when: 'مشغّلون بخريطة مقاعد', desc: 'اختر مقعدًا محدّدًا عند الحجز. تحمل التذكرة الإلكترونية رقم المقعد ويفرضه المشغّل عند الصعود.' },
        { name: 'Open seating', when: 'مشغّلون بلا خريطة مقاعد', desc: 'يُطلَب المقعد عند الصعود. لا تضمن التذكرة الإلكترونية سوى مكان على تلك المغادرة.' },
        { name: 'VIP class', when: 'مسارات طويلة المدى متميّزة', desc: 'مقاعد أوسع، وأحيانًا جلوس بثلاثة عرضًا (2+1) بدلًا من 2+2 القياسي، ولدى بعض المشغّلين تتضمّن مرطّبات خفيفة.' },
        { name: 'Standard class', when: 'الافتراضي', desc: 'جلوس حافلة قياسي، دون مشمولات إضافية. الأرخص والأكثر شيوعًا.' },
      ],
    },
    examples: [
      {
        title: 'طهران ← أصفهان · درجة VIP · راكبان',
        rows: [
          { label: 'الأجرة الأساسية (لكل راكب) × 2', value: '1,600,000' },
          { label: 'Retail MARKUP · +6%', value: '+96,000', accent: 'success' },
          { label: 'إجمالي المسافر', value: '1,696,000', strong: true },
        ],
        note: 'الحافلة منتج ضيّق الهامش — التسعير بـ Retail فقط هو القاعدة؛ ينشر المشغّل الأجرة، وتُضاف حصة الوكالة عند Retail.',
      },
    ],
    related: ['trains-search', 'ground', 'markup'],
  },

  // ── Flights funnel (search → results → passengers → seats → payment → ticket, + manual) ──
  'flights-results': {
    title: 'نتائج الرحلات',
    tag: 'البحث عن الرحلات الجوية',
    tagline: 'كل أجرة قابلة للإصدار للرحلة، مدمجة ومرتّبة — اختر التي تُصدَر تذكرتها.',
    business: {
      lead: 'شاشة النتائج هي حيث يصبح التسعير خيارًا. كل صف أجرة يمكن للوكالة إصدارها فعليًا (own SIGN أو partner SIGN)، والسعر المعروض يحمل بالفعل هوامش Wholesale / Distribution / Retail، وSIGN المُصدِر ظاهر بحيث يعرف الوكيل كيف ستُلبَّى التذكرة قبل الالتزام.',
      points: [
        { title: 'قائمة واحدة مدمجة ومرتّبة', desc: 'تُدمج الأسعار من كل مورّد نشط وتُرتَّب حسب السعر، فيقارن الوكيل المِثل بالمِثل بدلًا من التنقل بين علامات التبويب عبر القنوات.' },
        { title: 'السعر شامل الكل', desc: 'ما يظهر على الصف هو ما يدفعه المسافر — طبقات محرّك التسعير مُطبَّقة بالفعل.' },
        { title: 'المقارنة على ما يهمّ', desc: 'الأمتعة وقابلية الاسترداد والتوقفات ووقت المغادرة تحرّك القرار بقدر السعر الرئيسي.' },
      ],
    },
    software: {
      lead: 'قائمة أسعار قابلة للتصفية والفرز مع شريط أرخص أجرة حسب التاريخ.',
      points: [
        { title: 'التصفية والفرز', desc: 'الشريط الجانبي يضيّق حسب التوقفات ونطاق السعر وشركات الطيران ووقت المغادرة / الوصول ونوع الأجرة والمصدر.' },
        { title: 'مسح شريط الأسعار', desc: 'تقويم مصغّر يُظهر أرخص أجرة لكل تاريخ ±7 أيام؛ انقر تاريخًا لإعادة تشغيل البحث.' },
        { title: 'اقرأ الصف ثم اختر', desc: 'كل بطاقة تُظهر مسار المقطع وبطاقات الأمتعة و(في البحث والحجز) الصافي / الهامش / العمولة؛ واختيار أجرة يحمل تقسيمها لكل راكب إلى خطوة الركاب.' },
      ],
    },
    related: ['flights-search', 'flights-passengers', 'markup'],
  },

  'flights-manual': {
    title: 'الإدخال اليدوي للرحلة',
    tag: 'تذكرة خارج القناة',
    tagline: 'سجّل رحلة محجوزة خارج المنصّة لتعيش في دفتر الطلبات كأي رحلة أخرى.',
    business: {
      lead: 'ليست كل تذكرة تأتي من مسار البحث — فبعضها يُصدَر مباشرةً مع شركة طيران، أو عبر مجمِّع، أو عبر الهاتف. يلتقط الإدخال اليدوي تلك التذاكر بحيث تُتابَع حجوزاتها وركّابها وأموالها وتُفوتَر ويُبلَّغ عنها جنبًا إلى جنب مع المبيعات عبر الإنترنت.',
      points: [
        { title: 'دفتر طلبات واحد', desc: 'لا يبقى شيء يُباع خارج النظام غير مرئي — تنضمّ التذكرة اليدوية إلى كل الحجوزات كأي طلب آخر.' },
        { title: 'الهامش لا يزال يُبلَّغ', desc: 'يُلتقَط تفصيل الأجرة الكامل (الأساسية، الضرائب، الرسوم، الهامش، العمولة)، فيبقى تقرير الربح مكتملًا.' },
        { title: 'دعم متعدد الأرجل', desc: 'يمكن إدخال مسارات الذهاب فقط والذهاب والعودة والمتعددة المدن جميعها، بتذكرة إلكترونية واحدة لكل راكب لكل رجل.' },
      ],
    },
    software: {
      lead: 'نموذج مُهيكَل لإدخال مسار الرحلة والمورّد والتذاكر الإلكترونية لكل راكب.',
      points: [
        { title: 'بناء مسار الرحلة', desc: 'نوع الرحلة إضافةً إلى بطاقات الأرجل — مطارا المنشأ / الوجهة، شركة الطيران، الأوقات، الطائرة، المقصورة والمقعد.' },
        { title: 'ضبط المصدر والمال', desc: 'مصدر / مورّد الحجز، رمز الجولة والعملة، مع تفصيل أجرة لكل رجل.' },
        { title: 'تعيين التذاكر ثم المتابعة', desc: 'تُعيَّن تذكرة إلكترونية واحدة لكل راكب على الأرجل؛ تابع إلى خطوة الركاب.' },
      ],
    },
    related: ['flights-search', 'flights-passengers', 'bookings'],
  },

  'flights-passengers': {
    title: 'ركّاب الرحلة',
    tag: 'تفاصيل المسافر',
    tagline: 'سمِّ كل مسافر، واختر درجة الأجرة، والتقط التفاصيل التي تحتاجها شركة الطيران للإصدار.',
    business: {
      lead: 'خطوة الركاب هي حيث يصبح العرض حجزًا مُسمّى قابلًا للإصدار. تفاصيل الوثيقة والاتصال المُدخَلة هنا هي ما تتحقّق منه شركة الطيران عند الإصدار وما تفحصه الحدود عند السفر — وإتقانها من أول مرة يتفادى إعادة إصدار مكلفة.',
      points: [
        { title: 'درجة الأجرة خيار تجاري', desc: 'Saver / Flex / Plus تقايض السعر بالأمتعة وقابلية الاسترداد والمقعد والوجبة — يختار الوكيل الدرجة التي تناسب المسافر.' },
        { title: 'بيانات جواز السفر إلزامية', desc: 'الاسم وتاريخ الميلاد والجنسية ورقم جواز السفر وانتهاؤه هي مدخلات إصدار شركة الطيران، لا إضافات اختيارية.' },
        { title: 'التعبئة المسبقة من CRM توفّر النقرات', desc: 'اختيار عميل محفوظ يعبّئ مسافريه تلقائيًا من إدارة علاقات العملاء، فيُدخَل الراكب العائد مرة ويُعاد استخدامه.' },
      ],
    },
    software: {
      lead: 'شبكة درجات أجرة إضافةً إلى بطاقة هوية واحدة لكل مسافر وكتلة اتصال على مستوى الرحلة.',
      points: [
        { title: 'اختيار درجة الأجرة', desc: 'شبكة تقارن الدرجات حسب الأمتعة والاسترداد والمقعد والوجبة ونقاط المسافر الدائم.' },
        { title: 'ملء بطاقة كل راكب', desc: 'اللقب والاسم وتاريخ الميلاد والجنسية ورقم المسافر الدائم وجواز السفر وانتهاؤه، إضافةً إلى بطاقات SSR للوجبة / المقعد.' },
        { title: 'إضافة الاتصال ثم المتابعة', desc: 'بريد إلكتروني وهاتف برمز اتصال للحجز؛ تابع إلى اختيار المقعد الاختياري أو مباشرةً إلى الدفع.' },
      ],
    },
    related: ['flights-results', 'flights-seats', 'flights-payment', 'customers'],
  },

  'flights-seats': {
    title: 'اختيار المقعد',
    tag: 'إضافة اختيارية',
    tagline: 'عيّن المقاعد على خريطة تفاعلية — أو تخطَّ ودع شركة الطيران تخصّص.',
    business: {
      lead: 'اختيار المقعد خدمة إضافية اختيارية وغالبًا مدفوعة. اختيار المقاعد مسبقًا يحسّن تجربة المسافر ويمكن أن يضيف هامشًا حيث تكون الخريطة مدفوعة؛ والتخطّي يترك التخصيص لشركة الطيران عند تسجيل الوصول دون رسم. وفي كلتا الحالتين يمضي الحجز.',
      points: [
        { title: 'اختيارية دائمًا', desc: 'تخطَّ وتخصّص شركة الطيران المقاعد عند تسجيل الوصول — لا يُحجَب الحجز أبدًا على هذه الخطوة.' },
        { title: 'المدفوع مقابل المجاني يتفاوت', desc: 'المقاعد القياسية والمفضّلة وذات المساحة الإضافية للأرجل قد تحمل رسومًا مختلفة حسب الأجرة والناقل.' },
        { title: 'لكل راكب', desc: 'يُعيَّن لكل مسافر على الحجز مقعده الخاص.' },
      ],
    },
    software: {
      lead: 'خريطة مقاعد مُصيَّرة للطائرة، بشريط جانبي للركاب وعدّاد تعيين جارٍ.',
      points: [
        { title: 'قراءة الخريطة', desc: 'الشبكة تُظهر المقاعد المتاحة والمشغولة والمختارة لتخطيط الطائرة.' },
        { title: 'تعيين كل مسافر', desc: 'اختر مقعدًا لكل راكب من الشريط الجانبي؛ ويتتبّع التذييل عدد المُعيَّنين.' },
        { title: 'التخطّي أو المتابعة', desc: 'احفظ التعيينات أو تخطَّ؛ كلاهما يتقدّم إلى الدفع. (خريطة المقاعد نفسها تخدم الحافلات.)' },
      ],
    },
    related: ['flights-passengers', 'flights-payment'],
  },

  'flights-payment': {
    title: 'دفع الرحلة',
    tag: 'التحصيل والإصدار',
    tagline: 'اختر كيف يُدفَع الحجز، ثم أصدِر التذكرة.',
    business: {
      lead: 'الدفع هو حيث تُلتزَم الأموال وتُصدَر التذكرة. تحدّد الطريقة كيفية تحرّك الأموال — فورًا من محفظة الوكالة أو خط الائتمان، أو عبر بطاقة / بوابة / POS / تحويل بنكي يسجّله الوكيل — ويُظهر ملخّص الطلب للوكيل هامشه وعمولته قبل الالتزام.',
      points: [
        { title: 'المحفظة والائتمان فوريان', desc: 'كلاهما يُسحَب من حساب الوكالة، فيمكن إصدار التذكرة دون انتظار قناة خارجية.' },
        { title: 'القنوات الإيرانية مدعومة', desc: 'IPG (شاپرک / ZarinPal ونظائرهما)، وقارئ بطاقة POS، وتحويل بنكي Sheba، وبطاقة 3DS كلها طرق من الدرجة الأولى.' },
        { title: 'الهامش ظاهر قبل الإصدار', desc: 'في البحث والحجز، يُظهر الملخّص الصافي / الهامش / العمولة فيلتزم الوكيل وعيناه مفتوحتان.' },
      ],
    },
    software: {
      lead: 'منتقي طريقة دفع بحقول خاصة بكل طريقة وشريط جانبي لملخّص الطلب.',
      points: [
        { title: 'اختيار الطريقة', desc: 'المحفظة، خط الائتمان، بطاقة العميل، النقد، IPG، POS أو التحويل البنكي — كل منها بطاقة اختيار.' },
        { title: 'ملء نموذج الطريقة', desc: 'بطاقة 3DS؛ بوابة IPG + هاتف + مرجع؛ محطة POS / RRN / أثر؛ Sheba مصدر ووجهة IBAN + مرجع.' },
        { title: 'إضافة الفاتورة ثم الإصدار', desc: 'المُفوتَر إليه وVAT وتفاصيل أمر الشراء على كتلة الفاتورة؛ و«ادفع وأصدِر» ينشئ الطلب وينتقل إلى التذكرة.' },
      ],
    },
    modes: {
      lead: 'طرق الدفع نفسها متاحة عبر المنتجات — الاختيار يتعلق بكيفية ووقت تسوية الأموال.',
      modes: [
        { name: 'Wallet', when: 'الافتراضية / الموصى بها', desc: 'يُخصَم في الوقت الفعلي من رصيد الوكالة المدفوع مسبقًا. أسرع طريق للإصدار؛ دون خطوة خارجية.' },
        { name: 'Credit line', when: 'لدى الوكالة حدّ ائتماني', desc: 'يُسحَب من ائتمان الوكالة قصير الأجل؛ ويُسوّى لاحقًا وفق شروط الائتمان.' },
        { name: 'IPG link', when: 'يدفع العميل عبر الإنترنت', desc: 'يُرسَل رابط دفع عبر بوابة إيرانية (شاپرک / ZarinPal / IDPay…) إلى العميل؛ ويُسجَّل مرجع البوابة عند العودة.' },
        { name: 'POS', when: 'البطاقة حاضرة عند المكتب', desc: 'يُحصَّل على قارئ بطاقة الفرع؛ ويُدخَل معرّف المحطة وRRN ورقم الأثر كإثبات.' },
        { name: 'Bank transfer (Sheba)', when: 'إيداع IBAN مباشر', desc: 'يُسجَّل IBAN المصدر والوجهة لـ Sheba إضافةً إلى مرجع التحويل للتسوية.' },
      ],
    },
    related: ['flights-passengers', 'flights-ticket', 'counter', 'markup'],
  },

  'flights-ticket': {
    title: 'تذكرة الرحلة',
    tag: 'تذكرة إلكترونية مُصدَرة',
    tagline: 'التذكرة الإلكترونية المُصدَرة — PNR والراكب ومسار الرحلة وربح الوكيل على البيع.',
    business: {
      lead: 'صفحة التذكرة هي إثبات البيع — أرقام PNR والتذكرة الإلكترونية التي يحملها المسافر وتشير إليها الوكالة لأي إجراء خدمة. كما تُغلق الحلقة التجارية، إذ تُظهر للوكيل الهامش المُحقَّق (البيع − التكلفة + العمولة) على الحجز.',
      points: [
        { title: 'وثيقة المسافر', desc: 'PNR ورقم التذكرة، ومسار الرحلة الكامل، والمقعد وحالة الحجز في مكان واحد.' },
        { title: 'الخدمة تبدأ هنا', desc: 'أرسِل مسار الرحلة بالبريد الإلكتروني، وانسخ المرجع، وعدّل الحجز أو أثِر استردادًا من الإجراءات السريعة.' },
        { title: 'الربح مُحقَّق', desc: 'ملخّص الماليات (البيع، التكلفة، الهامش، العمولة، الربح) يجعل الهامش على هذا البيع صريحًا.' },
      ],
    },
    software: {
      lead: 'تذكرة بنمط قسيمة، بالرحلة والراكب والماليات مرتّبة.',
      points: [
        { title: 'الترويسة وشريط الراكب', desc: 'PNR، وتسمية التذكرة الإلكترونية، واسم الراكب، ورقم التذكرة، والمسافر الدائم، ووقت الإصدار.' },
        { title: 'شبكة مسار الرحلة', desc: 'رقم الرحلة، والطائرة، والمقصورة، ودرجة الأجرة، وأوقات المغادرة / الوصول والتوقفات.' },
        { title: 'الماليات والإجراءات', desc: 'شريط جانبي للهامش إضافةً إلى ضوابط البريد الإلكتروني / النسخ / التعديل / الاسترداد.' },
      ],
    },
    related: ['flights-payment', 'bookings', 'booking-detail', 'refunds'],
  },

  // ── Trains funnel (search → results → seats & pax → payment → ticket, + manual) ──
  'trains-results': {
    title: 'نتائج القطارات',
    tag: 'البحث عن السكك الحديدية',
    tagline: 'كل مغادرات اليوم، مرتّبة — اختر القطار والدرجة للحجز.',
    business: {
      lead: 'نتائج السكك أكثر ثباتًا من الطيران: جدول اليوم وأجوره تصمد، فيقارن الوكيل على الوقت والدرجة وقابلية الاسترداد بدلًا من مطاردة سعر متحرّك. كل صف مغادرة قابلة للحجز بخيارات درجتها والمقاعد المتبقية.',
      points: [
        { title: 'الأسعار مستقرّة', desc: 'يصمد السعر نفسه عادةً طوال يوم التشغيل، فيبقى التسعير صالحًا أطول من أجرة الرحلة الجوية.' },
        { title: 'قارِن الدرجة لا الناقل', desc: 'القرار بين أنواع العربات والراحة على المسار، لا بين شركات طيران متنافسة.' },
        { title: 'قابلية الاسترداد مسبقًا', desc: 'كل صف موسوم قابل للاسترداد / جزئي / غير قابل للاسترداد قبل أن يلتزم الوكيل.' },
      ],
    },
    software: {
      lead: 'قائمة رحلات بالمشغّل والأوقات ونوع العربة والسعر لكل درجة، إضافةً إلى شريط أسعار.',
      points: [
        { title: 'تصفية اليوم', desc: 'الشريط الجانبي يضيّق حسب الفرز وإخفاء المُباع بالكامل والمشغّل والمدرّج التكراري للسعر ونوع العربة وفترة اليوم.' },
        { title: 'مسح شريط الأسعار', desc: 'تقويم مصغّر ±7 أيام يُظهر أرخص سعر لكل تاريخ؛ انقر لإعادة البحث.' },
        { title: 'اختيار مغادرة', desc: 'تُظهر الصفوف المشغّل والأوقات والتوقفات والمقاعد المتبقية وبطاقات الاسترداد؛ والاختيار يتقدّم إلى المقاعد والركاب.' },
      ],
    },
    related: ['trains-search', 'trains-passengers', 'markup'],
  },

  'trains-manual': {
    title: 'الإدخال اليدوي للقطار',
    tag: 'تذكرة خارج القناة',
    tagline: 'سجّل تذكرة سكك محجوزة خارج المنصّة في دفتر الطلبات.',
    business: {
      lead: 'تُشترى بعض تذاكر السكك مباشرةً في محطة أو مكتب مشغّل. يُدخِلها الإدخال اليدوي إلى دفتر الطلبات نفسه بحيث تُتابَع وتُفوتَر ويُبلَّغ عنها جنبًا إلى جنب مع مبيعات السكك عبر الإنترنت — فلا يسقط حجز من بين الثغرات.',
      points: [
        { title: 'دفتر طلبات واحد', desc: 'تذكرة سكك خارج القناة تنضمّ إلى كل الحجوزات كأي طلب آخر.' },
        { title: 'الهامش لا يزال يُبلَّغ', desc: 'يُلتقَط تفصيل الأجرة فيبقى تقرير الربح مكتملًا.' },
        { title: 'مسار رحلة على مستوى المحطة', desc: 'تُدخَل الأرجل حسب المحطة، بما يطابق كيف تُباع السكك فعليًا.' },
      ],
    },
    software: {
      lead: 'نموذج الإدخال اليدوي للنقل المشترك، مُدخَل للسكك.',
      points: [
        { title: 'إدخال الرحلة', desc: 'أرجل بمحطات ومشغّل وأوقات ودرجة.' },
        { title: 'ضبط المصدر والمال', desc: 'المورّد والعملة وتفصيل أجرة لكل رجل.' },
        { title: 'تعيين التذاكر ثم المتابعة', desc: 'تذكرة واحدة لكل راكب؛ تابع إلى خطوة الركاب.' },
      ],
    },
    related: ['trains-search', 'trains-passengers', 'bookings'],
  },

  'trains-passengers': {
    title: 'مقاعد وركّاب القطار',
    tag: 'الدرجة والمقعد والركاب',
    tagline: 'اختر الدرجة، واختر مقاعد العربة على الخريطة، وسمِّ المسافرين.',
    business: {
      lead: 'تدمج السكك اختيار الدرجة وخريطة المقعد في خطوة واحدة. تحدّد الدرجة الراحة والمشمولات؛ وتربط خريطة العربة / المقعد التذكرة بمكان مادي (يفرض كثير من المشغّلين مقصورات مراعية للجنس)؛ وتُنهي تفاصيل المسافر الحجز.',
      points: [
        { title: 'الدرجة هي الرافعة', desc: 'Standard / Premier / Comfort تقايض السعر بالمزايا — قرار الوكيل الرئيسي على السكك.' },
        { title: 'المقعد يربط التذكرة', desc: 'تُختار عربة ومقعد على الخريطة؛ والمحجوز مقابل المفتوح يعتمد على المشغّل.' },
        { title: 'حقول وثائق أقل من الطيران', desc: 'تحتاج السكك الاسم والاتصال والولاء — لا مجموعة جواز السفر / APIS الكاملة التي تتطلّبها الرحلة الجوية.' },
      ],
    },
    software: {
      lead: 'منتقي درجة، وخريطة عربة / مقعد تفاعلية، ونموذج راكب.',
      points: [
        { title: 'اختيار الدرجة', desc: 'بطاقات تقارن السعر والمزايا لكل درجة سفر.' },
        { title: 'اختيار العربة والمقعد', desc: 'بدّل العربات واختر المقاعد على شبكة (متاح / مشغول / مختار)، مع مفتاح لوسائل الراحة.' },
        { title: 'تسمية المسافرين', desc: 'اللقب والاسم والبريد الإلكتروني والهاتف ومعرّف الولاء لكل راكب؛ تابع إلى الدفع.' },
      ],
    },
    related: ['trains-results', 'trains-payment', 'customers'],
  },

  'trains-payment': {
    title: 'دفع القطار',
    tag: 'التحصيل والإصدار',
    tagline: 'اختر كيف يُدفَع حجز السكك، ثم أصدِر التذكرة — قبل انتهاء قفل المقعد.',
    business: {
      lead: 'الدفع يلتزم الأجرة ويصدر تذكرة السكك. ولأن المقعد يُحتجَز لنافذة قفل قصيرة فقط بعد الاختيار، فإن إتمام الدفع بسرعة هو ما يؤمّنه. تحدّد الطريقة كيفية تحرّك الأموال — محفظة / ائتمان فورًا، أو بوابة / POS / تحويل يسجّله الوكيل.',
      points: [
        { title: 'المقعد على مؤقّت', desc: 'الاختيار يضع احتجازًا قصيرًا؛ ادفع قبل انتهائه وإلا حُرِّر المقعد.' },
        { title: 'المحفظة والائتمان فوريان', desc: 'كلاهما يُسحَب من حساب الوكالة للإصدار الفوري.' },
        { title: 'القنوات الإيرانية مدعومة', desc: 'IPG وPOS وتحويل بنكي Sheba كلها متاحة إلى جانب المحفظة والائتمان.' },
      ],
    },
    software: {
      lead: 'منتقي طريقة دفع بحقول خاصة بكل طريقة وملخّص دفع.',
      points: [
        { title: 'اختيار الطريقة', desc: 'المحفظة، الائتمان، البطاقة، IPG، POS أو تحويل Sheba.' },
        { title: 'ملء نموذج الطريقة', desc: 'بوابة IPG + هاتف + مرجع؛ محطة POS / RRN / أثر؛ Sheba مصدر ووجهة IBAN + مرجع.' },
        { title: 'لاحظ القفل ثم أصدِر', desc: 'شريط قفل مقعد يُظهر ما هو محتجَز؛ و«ادفع وأصدِر» يحصّل وينتقل إلى التذكرة.' },
      ],
    },
    modes: {
      lead: 'طرق الدفع نفسها متاحة عبر المنتجات — الاختيار يتعلق بكيفية ووقت تسوية الأموال.',
      modes: [
        { name: 'Wallet', when: 'الافتراضية / الموصى بها', desc: 'يُخصَم في الوقت الفعلي من رصيد الوكالة المدفوع مسبقًا. أسرع طريق للإصدار.' },
        { name: 'Credit line', when: 'لدى الوكالة حدّ ائتماني', desc: 'يُسحَب من ائتمان قصير الأجل؛ ويُسوّى لاحقًا وفق الشروط.' },
        { name: 'IPG link', when: 'يدفع العميل عبر الإنترنت', desc: 'يُرسَل رابط بوابة (شاپرک / ZarinPal…) إلى العميل؛ ويُسجَّل المرجع عند العودة.' },
        { name: 'POS', when: 'البطاقة حاضرة عند المكتب', desc: 'يُحصَّل على قارئ الفرع؛ ويُدخَل معرّف المحطة وRRN والأثر.' },
        { name: 'Bank transfer (Sheba)', when: 'إيداع IBAN مباشر', desc: 'يُسجَّل IBAN المصدر / الوجهة لـ Sheba ومرجع التحويل.' },
      ],
    },
    related: ['trains-passengers', 'trains-ticket', 'counter'],
  },
};
